function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { forwardRef, memo } from 'react';
import merge from 'lodash/merge';
import { withStyles } from '@material-ui/core/styles';
import MuiInputLabel from '@material-ui/core/InputLabel';
import { getPxToRemSelector, getColorTextSelector, getColorErrorSelector } from '@signal/theme';
var labelFontSizeSelector = getPxToRemSelector(18);
var colorTextSecondarySelector = getColorTextSelector('secondary');
var colorErrorSelector = getColorErrorSelector();
export var InputLabelBase = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (props, ref) {
  var classes = props.classes,
      FormLabelClasses = props.FormLabelClasses,
      InputLabelClasses = props.InputLabelClasses,
      rest = _objectWithoutProperties(props, ["classes", "FormLabelClasses", "InputLabelClasses"]);

  return /*#__PURE__*/React.createElement(MuiInputLabel, Object.assign({
    classes: merge({
      root: classes.inputLabelRoot
    }, InputLabelClasses),
    FormLabelClasses: merge({
      focused: classes.formLabelFocused,
      error: classes.formLabelError
    }, FormLabelClasses),
    ref: ref
  }, rest));
}));
export var inputLabelStyles = function inputLabelStyles(theme) {
  return {
    inputLabelRoot: {
      fontSize: labelFontSizeSelector(theme),
      color: colorTextSecondarySelector(theme)
    },
    formLabelFocused: {
      color: colorTextSecondarySelector(theme)
    },
    formLabelError: {
      color: colorErrorSelector(theme)
    }
  };
};
export var InputLabel = withStyles(inputLabelStyles, {
  name: 'InputLabel'
})(InputLabelBase);